import { PaletteIcon } from './PaletteIcon';

/**
 * author: Google
 * id 954CCE2B-7FEE-4F9C-9923-4E1D567607C3
 * name palette
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/palette.svg
 * tags
 * - Color 
 * - Drawing / Art 
 */
export const ArtIcon = PaletteIcon;
export default ArtIcon